/* eslint-disable import/prefer-default-export */
/**
 * Common properties for form components
 */

export enum AmCreateFormType {
    CREATE = 'CREATE',
    COPY = 'COPY',
    SUPPLEMENT = 'SUPPLEMENT',
}

export interface AmCreateModalFormBaseProps {
    title: String;
    toggleButton: JSX.Element;
    formType: AmCreateFormType;
    onSubmit?: () => void;
}
